
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ads",
      function () {
        return require("private-next-pages/ads.tsx");
      }
    ]);
  